import type {RutaProd} from '../../../../runtime/rutas';
export default {ruta:'/sistema/catalogos/promociones',documento:'catalogs',acceso:'sesion',filas:['060'],cita:'Areas/Catalogs/Controllers/PromotionsController.cs:52'} satisfies RutaProd;
